import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="team-filter"
export default class extends Controller {
  static targets = ["form", "localeInput", "nearMeCheckbox"]

  connect() {
    // Initialize
  }

  setLocale(event) {
    event.preventDefault()
    const locale = event.currentTarget.dataset.locale
    this.localeInputTarget.value = locale
    this.submitForm()
  }

  submitForm() {
    // Find the form and submit it
    const form = this.element.querySelector('form')
    if (form) {
      form.requestSubmit()
    }

  }
}
